import axios from "axios";
import api from "./api";
import API_BASE_URL from "../config/apiConfig";

// Admin: the emergency contacts and when each is on duty.
export const listEmergencyContacts = async () => (await api.get("/api/admin/emergency-contacts")).data;
export const saveEmergencyContact = async (contact) =>
  (contact.id
    ? await api.put(`/api/admin/emergency-contacts/${contact.id}`, contact)
    : await api.post("/api/admin/emergency-contacts", contact)
  ).data;
export const deleteEmergencyContact = (id) => api.delete(`/api/admin/emergency-contacts/${id}`);

// Customer trip page: only whoever is on duty right now.
export const getPublicEmergencyContacts = async (token) =>
  (await axios.get(`${API_BASE_URL}/api/tracking/${encodeURIComponent(token)}/emergency-contacts`)).data;

export const WEEK_DAYS = [
  ["MON", "Mon"],
  ["TUE", "Tue"],
  ["WED", "Wed"],
  ["THU", "Thu"],
  ["FRI", "Fri"],
  ["SAT", "Sat"],
  ["SUN", "Sun"],
];

/** "20:00" -> "8:00 PM". */
export function formatClock(value) {
  const [hours, minutes] = String(value || "").split(":").map(Number);
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return "-";
  const suffix = hours >= 12 ? "PM" : "AM";
  return `${hours % 12 || 12}:${String(minutes).padStart(2, "0")} ${suffix}`;
}

/** wa.me wants the number with its country code and nothing else; Indian numbers are often saved without it. */
export function whatsappLink(phone) {
  let digits = String(phone || "").replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("0")) digits = digits.slice(1);
  if (digits.length === 10) digits = `91${digits}`;
  return digits ? `https://wa.me/${digits}` : "";
}

export function telLink(phone) {
  const callable = String(phone || "").trim().replace(/[^\d+]/g, "");
  return callable ? `tel:${callable}` : "";
}
